import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import * as SubscriptionActions from '@store/subscription/subscription.actions';
import { map, of, switchMap } from 'rxjs';
import { catchError, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { UserRepository } from '@core/repositories';
import { sessionSelectors } from '@store/session';
import { subscriptionSelectors } from '@store/subscription/subscription.selectors';
import { ErrorResponse } from '@core/models';


@Injectable()
export class SubscriptionEffects {

  loadFollowings = createEffect(() => {
    return this.actions.pipe(
      ofType(SubscriptionActions.loadFollowings),
      concatLatestFrom(() => [
        this.store.select(subscriptionSelectors.selectFollowingsNextPage),
        this.store.select(sessionSelectors.selectSessionUserId),
      ]),
      filter(([, , userId]) => !!userId),
      switchMap(([{ isExpired }, nextPage, userId]) => {
        return this.userRepository.getUserFollowings(userId ?? '', isExpired, nextPage).pipe(
          map((response) => SubscriptionActions.loadFollowingsSuccess({ data: response.data })),
          catchError((error: unknown) => of(SubscriptionActions.loadFollowingsFailure({ error: error as ErrorResponse }))),
        );
      }),
    );
  });

  loadFollowers = createEffect(() => {
    return this.actions.pipe(
      ofType(SubscriptionActions.loadFollowers),
      concatLatestFrom(() => [
        this.store.select(subscriptionSelectors.selectFollowersNextPage),
        this.store.select(sessionSelectors.selectSessionUserId),
      ]),
      filter(([, , userId]) => !!userId),
      switchMap(([, nextPage, userId]) =>
        this.userRepository.getUserFollowers(userId ?? '', nextPage).pipe(
          map((response) => SubscriptionActions.loadFollowersSuccess({ data: response.data })),
          catchError((error: unknown) => of(SubscriptionActions.loadFollowersFailure({ error: error }))),
        )),
    );
  });

  constructor(
    private store: Store,
    private actions: Actions,
    private userRepository: UserRepository,
  ) {}

}
